import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {LiveCasinoNavbarCipBox} from "./live-casino-navbar.cip.box";
import {LiveCasinoNavbarCasino777Box} from "./live-casino-navbar.casino777.box";
import {LiveCasinoNavbarDefaultBox} from "./live-casino-navbar.default.box";
import {LiveCasinoNavbarCisBox} from "./live-casino-navbar.cis.box";
import { LiveCasinoNavbarSICisBox } from "./live-casino-navbar.siCis.box";
import {LiveCasinoNavbarMrGreenBox} from "./live-casino-navbar.mrgreen.box";
import { LiveCasinoNavbarMrGreenCisBox } from "./live-casino.navbar.mrgreenCis.box";

export const LiveCasinoNavbarBox = styledByTheme(LiveCasinoNavbarDefaultBox)
                                    .forCip(LiveCasinoNavbarCipBox)
                                    .forCis(LiveCasinoNavbarCisBox)
                                    .forSICis(LiveCasinoNavbarSICisBox)
                                    .forWsopCip(LiveCasinoNavbarCipBox)
                                    .forCasino777(LiveCasinoNavbarCasino777Box)
                                    .forMrGreen(LiveCasinoNavbarMrGreenBox)
                                    .forMrGreenCis(LiveCasinoNavbarMrGreenCisBox)
                                    .apply();
